import React, { memo } from "react";

import { EnumItem } from "types/enums/createcustomEnum";

import styles from "./addressSection.module.scss";

type AddressTextBlockProps = {
	label: string;
	value: string | EnumItem;
	isDisabled?: boolean;
};

const AddressTextBlock = ({
	label,
	value,
	isDisabled = false,
}: AddressTextBlockProps) => {
	const isDisabledClass = isDisabled ? styles.isDisabled : "";

	return (
		<div className={`${styles.wrapAddressBlock} ${isDisabledClass}`}>
			<div className={styles.label}>{label}</div>
			<div className={styles.text}>
				{(typeof value === "object" ? value?.displayName : value) ?? ""}
			</div>
		</div>
	);
};

export default memo(AddressTextBlock);
